import '../vendor';

import '../general/ofi';
import '../general/signlogin';
import '../general/reg';
import '../general/modal';
import '../general/menu';
import '../general/filter';
import '../general/full-screen';

import '../pages/media/media';


// WEBPACK FOOTER //
// ./src/js/pages/media.js